import React from 'react';

const ChevronUpIcon = () => {
  return (
    <svg className="chevron-up-icon" width="15" height="9" viewBox="0 0 15 9" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M.707 8.39l7.071-7.072-.707-.707L0 7.682z" />
        <path d="M13.925 8.646L6.854 1.575 7.56.868l7.07 7.07z" />
      </g>
    </svg>
  );
};

export default ChevronUpIcon;
